module.exports = __webpack_public_path__ + "static/elastic-logo-H-full color-3ca8c9e5adcc355c3303596c9be764de.png";